import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { patchData, getRemoteUrl } from './request'
import { addCases } from './utils'
import { getLoginToken } from './store'


function setErrorState(state, { error }) {
    state.isLoading = false
    state.error = error
    state.success = false
}

function setPasswordChanged(state) {
    state.isLoading = false
    state.success = true
    delete state.error
}

function setPasswordChanging(state) {
    state.isLoading = true
    delete state.error
    delete state.success
}

function changeUserPassword({ current_password, new_password }) {
    const loginToken = getLoginToken()
    const payload = {
        current_password: current_password,
        new_password: new_password
    }

    return patchData(getRemoteUrl("users/me/password"), payload, loginToken)
        .catch(err => {
            if (err && err.status === 400) {
                throw new Error('Неверный текущий пароль')
            }

            throw err
        })
}

export const asyncChangePassword = createAsyncThunk('asyncChangePassword', changeUserPassword)

export const passwordSlice = createSlice({
    name: 'password',
    initialState: {
        isLoading: false,
        success: false
    },
    reducers: {
        resetPasswordState(state) {
            state.isLoading = false
            state.success = false
            delete state.error
        }
    },
    extraReducers: builder => {
        addCases(builder, asyncChangePassword, setPasswordChanged, setPasswordChanging, setErrorState)
    }
})

export const { resetPasswordState } = passwordSlice.actions
